import { CreateProjectGroup } from '@/connection/projects/create-project-group';
import { serializeError } from '@/store/utils/serialize-error';
import { ProjectsReducerCreator } from '../types';

const createProjectGroupReducer = (create: ProjectsReducerCreator) => {
  return create.asyncThunk(
    async (
      {
        channel,
        name,
        projectUuids,
        adminIds,
      }: { channel: number; name: string; projectUuids: string[]; adminIds: number[] },
      { rejectWithValue }
    ) => {
      try {
        const newGroup = await CreateProjectGroup(channel, name, projectUuids, adminIds);
        return newGroup;
      } catch (error) {
        return rejectWithValue(serializeError(error));
      }
    },
    {
      rejected: (state, action) => {
        state.groupError = action.error.message || 'Error creating project group';
      },
      fulfilled: (state, action) => {
        state.groupError = '';
        if (state.projectGroups) {
          state.projectGroups = [...state.projectGroups, action.payload];
        }
      },
    }
  );
};

export default createProjectGroupReducer;
